import { supabase } from '../supabase';

// Phase C.1b — Career Mode is an EXPERIENCE preference, never
// authorization (see migration 037's own header). Reads go direct
// against profile_career_modes' own self-scoped RLS policy; writes go
// through the two RPCs that are the only path to either table/column.

/** Every Career Mode the CALLER has enabled — profile_career_modes' own
 * RLS policy already restricts this to the caller's own rows, so no
 * profileId parameter is needed or accepted. Returns a plain array of
 * mode strings (e.g. ['fan','coach']), not the raw rows — callers never
 * need anything but the mode name. */
export async function listMyCareerModes() {
  const { data, error } = await supabase.from('profile_career_modes').select('mode');
  if (error) throw error;
  return (data || []).map(r => r.mode);
}

/** Enable or disable one Career Mode for the caller's own profile.
 * Disabling the currently-active mode also clears it back to null
 * server-side (set_career_mode_enabled()'s own behavior) — callers
 * should re-fetch/refresh profile + career modes together afterward. */
export async function setCareerModeEnabled(mode, enabled) {
  const { error } = await supabase.rpc('set_career_mode_enabled', { p_mode: mode, p_enabled: enabled });
  if (error) throw error;
}

/** Sets the caller's preferred/active Career Mode. Pass null to clear it
 * explicitly. Rejects (server-side) any mode the caller has not already
 * enabled. */
export async function setActiveCareerMode(mode) {
  const { error } = await supabase.rpc('set_active_career_mode', { p_mode: mode });
  if (error) throw error;
}
